import React from "react";
import styled from "styled-components";

const Hr = styled.hr`
  color: #f5f5f5;
  margin: 10px 1px 10px 0px;
`;

const Line = () => {
  return <Hr />;
};

export default Line;
